module.exports = __webpack_public_path__ + "img/flot3.3811e111.svg";